"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StarsReview = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Layout = require("../../atoms/Layout");

var _StarsReviewItem = require("../../atoms/StarsReviewItem");

var StarsReview = function StarsReview(_ref) {
  var onClick = _ref.onClick,
      maxRating = _ref.maxRating;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      selectedRating = _useState2[0],
      setSelectedRating = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      hoverRating = _useState4[0],
      setHoverRating = _useState4[1];

  var isSelected = function isSelected(index) {
    return selectedRating > index;
  };

  var isHovered = function isHovered(index) {
    return hoverRating > index;
  };

  var onStarClick = function onStarClick(index) {
    var rating = index + 1;

    if (isSelected(index) && selectedRating === index + 1) {
      rating = index;
    }

    setSelectedRating(rating);
    onClick(rating);
  };

  return _react.default.createElement(_Layout.Flex, {
    justifyContent: "center"
  }, (0, _toConsumableArray2.default)(Array(maxRating)).map(function (element, index) {
    return _react.default.createElement(_StarsReviewItem.StarsReviewItem, {
      key: index,
      index: index,
      selected: isSelected(index) || isHovered(index),
      onClick: function onClick() {
        onStarClick(index);
      },
      handleOnMouseOver: function handleOnMouseOver() {
        setHoverRating(index);
      },
      handleOnMouseLeave: function handleOnMouseLeave() {
        setHoverRating(0);
      },
      hasMargins: index < maxRating - 1
    });
  }));
};

exports.StarsReview = StarsReview;